import { render } from "./ManagementSidebar.vue?vue&type=template&id=de380a64&scoped=true"
import script from "./ManagementSidebar.vue?vue&type=script&lang=js"
export * from "./ManagementSidebar.vue?vue&type=script&lang=js"

import "./ManagementSidebar.vue?vue&type=style&index=0&id=de380a64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de380a64"]])

export default __exports__